<template>
  <div id="UserSettingDetail">
    <el-form
      :model="user"
      :rules="rules"
      ref="user"
      label-width="150px"
    >
      <div class="panel-box">
        <eb-panel>
          <div slot="body">
            <div class="row-field">
              <div class="row-left">
                <div class="logo-img">
                  <img
                    v-if="user.departLogo"
                    :src="departLogoImgSrc"
                  >
                  <img
                    v-if="!user.departLogo"
                    :src="$ebConfig.imgPath+'img/60x45.png'"
                  >
                </div>
              </div>
              <div class="row-right">
                <router-link
                  class="companyName"
                  to="/user/org/detail"
                >
                  {{user.companyName}}
                </router-link>
              </div>
            </div>
          </div>
        </eb-panel>
      </div>
      <div class="eb-line"></div>
      <div class="panel-box">
        <eb-panel>
          <eb-panel-header slot="header">
            <span slot="title">个人信息</span>
          </eb-panel-header>
          <div slot="body">
            <div class="row-field">
              <div class="row-left">
                <div class="head-img">
                  <img
                    v-if="user.headImg"
                    :src="headImgSrc"
                  >
                  <img
                    v-if="!user.headImg"
                    :src="$ebConfig.imgPath+'img/140x210.png'"
                  >
                </div>
              </div>
              <div class="row-right">
                <div class="i-font">
                  <i
                    class="icon iconfont icon-shanchu icon-select-rule-tpl"
                    @click="deleteHeadImgConfirm"
                  ></i>
                  <i
                    class="icon iconfont icon-modify1 icon-select-rule-tpl"
                    @click="uploadHeadImg(user.showName,user.userId)"
                  ></i>
                </div>
              </div>
            </div>
            <el-form-item
              label="用户名"
              prop="showName"
              class="firstItem"
            >
              <el-input
                class="eb-input"
                v-model="user.showName"
                placeholder="用户名"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="密码"
              prop="userPassword"
            >
              ******&nbsp;
              <i
                class="icon iconfont icon-modify1 icon-select-rule-tpl"
                @click="modifyUserPass(user.userPhone)"
              ></i>
            </el-form-item>
            <el-form-item
              label="用户编号"
              prop="userCode"
            >
              {{user.userCode}}
            </el-form-item>
            <el-form-item
              label="真实姓名"
              prop="trueName"
            >
              <el-input
                class="eb-input"
                v-model="user.trueName"
                placeholder="真实姓名"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="注册时间"
              prop="addTime"
            >
              {{user.addTime | dateTimeStandardFormatZh}}
            </el-form-item>
            <el-form-item
              label="最后登录"
              prop="lastLoginTime"
            >
              {{user.lastLoginTime | dateTimeStandardFormatZh}}
            </el-form-item>
          </div>
        </eb-panel>
      </div>
      <div class="eb-line"></div>
      <div class="panel-box">
        <eb-panel>
          <eb-panel-header slot="header">
            <span slot="title">联系方式</span>
          </eb-panel-header>
          <div slot="body">
            <el-form-item
              label="电子邮件"
              prop="userEmail"
            >
              <el-input
                class="eb-input"
                v-model="user.userEmail"
                placeholder="电子邮件"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="工作电话"
              prop="phone"
            >
              <el-input
                class="eb-input"
                v-model="user.phone"
                placeholder="工作电话"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="通讯地址"
              prop="address"
            >
              <el-input
                type="textarea"
                class="eb-textarea"
                v-model="user.address"
                placeholder="通讯地址"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="手机号码"
              prop="userPhone"
            >
              {{user.userPhone}}&nbsp;
              <i
                class="icon iconfont icon-modify1 icon-select-rule-tpl"
                @click="modifyUserPhone(user.userPhone)"
              ></i>
            </el-form-item>
            <el-form-item
              label="微信扫码登录"
              prop="openidPublic"
            >
              <template>
                <span v-if="user.openidPublic && user.openidPublic != ''">
                  已绑定&nbsp;
                  <img
                    :src="user.headimgurl"
                    width="25"
                    height="25"
                    style="vertical-align: middle;border-radius:50%;"
                  >&nbsp; {{user.nickname}}
                  <i
                    class="icon iconfont icon-shanchu icon-select-rule-tpl"
                    @click="unbindWxConfirm"
                  ></i>
                </span>
                <span v-else>
                  未绑定&nbsp;
                  <i
                    class="icon iconfont icon-modify1 icon-select-rule-tpl"
                    @click="wnBind(user.userId)"
                  ></i>
                </span>
              </template>
            </el-form-item>
            <el-form-item
              label="个人微信二维码"
              prop="wxQRCodeImg"
            >
              <template>
                <div class="wxQRCode-img">
                  <img
                    v-if="user.wxQRCodeImg"
                    :src="wxQRCodeImgSrc"
                  >
                  <img
                    v-if="!user.wxQRCodeImg"
                    :src="$ebConfig.imgPath+'img/147x147.png'"
                  >
                </div>
                <i
                  class="icon iconfont icon-shanchu icon-select-rule-tpl"
                  @click="removeWxQRCodeImgConfirm"
                ></i>
                <i
                  class="icon iconfont icon-modify1 icon-select-rule-tpl"
                  @click="uploadWxQRCode(user.showName,user.userId)"
                ></i>
              </template>
            </el-form-item>
          </div>
        </eb-panel>
      </div>
      <div class="eb-line"></div>
      <div class="panel-box">
        <eb-panel>
          <eb-panel-header slot="header">
            <span slot="title">部门信息</span>
          </eb-panel-header>
          <div slot="body">
            <el-form-item label="所属部门">
              <el-input
                class="eb-input"
                v-model="user.departName"
                disabled="disabled"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户角色">
              <el-input
                class="eb-input"
                v-model="user.userRoleNames"
                disabled="disabled"
              ></el-input>
            </el-form-item>
          </div>
        </eb-panel>
      </div>
      <div class="eb-line"></div>
      <div class="panel-box">
        <eb-panel>
          <eb-panel-header slot="header">
            <span slot="title">个人介绍</span>
          </eb-panel-header>
          <div slot="body">
            <el-form-item
              label-width="0px"
              prop="selfIntroduce"
            >
              <el-input
                type="textarea"
                v-model="user.selfIntroduce"
                :value="user.selfIntroduce"
                :rows="5"
                :maxlength="200"
                placeholder="请编辑自我介绍信息"
                class="eb-textarea"
              ></el-input>
            </el-form-item>
          </div>
        </eb-panel>
      </div>
      <div class="eb-line"></div>
      <div class="panel-box">
        <div class="eb-button-group">
          <el-button
            class="eb-button-group-btn eb-button-orange eb-button-big"
            @click="saveUserInfo('user')"
          >保存并关闭</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import eventBus from '@/plugins/event-bus';
import { setUser } from '@/services/user/user-service';
import { baseURL } from '@/plugins/axios';
export default {
  name: 'UserSettingDetail',
  props: ['user'],
  components: {
    ebPanel,
    ebPanelHeader
  },
  data() {
    let checkPhone = (rule, value, callback) => {
      let reg = /^[0-9-]*$/;
      if (!value) {
        callback();
      } else {
        if (!reg.test(value)) {
          callback(new Error('请输入有效的工作电话！'));
        } else {
          callback();
        }
      }
    };
    return {
      rules: {
        showName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在2 到 10 个字符', trigger: 'blur' }
        ],
        trueName: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        userEmail: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        phone: [
          { validator: checkPhone, trigger: 'blur' },
          { max: 20, message: '长度不能超过 20 个字符', trigger: 'blur' }
        ],
        address: [{ max: 200, message: '长度不能超过 200 个字符', trigger: 'blur' }],
        selfIntroduce: [{ max: 200, message: '长度不能超过 200 个字符', trigger: 'blur' }]
      }
    };
  },
  created() {
    eventBus.$on('modifyUserPhoneSucess', userNewPhone => {
      this.user.userPhone = userNewPhone;
    });
  },
  computed: {
    headImgSrc: {
      cache: true,
      get: function() {
        return baseURL + this.user.headImg + '?time=' + Date.now();
      }
    },
    wxQRCodeImgSrc: {
      cache: true,
      get: function() {
        return baseURL + this.user.wxQRCodeImg + '?time=' + Date.now();
      }
    },
    departLogoImgSrc: {
      cache: true,
      get: function() {
        return baseURL + this.user.departLogo + '?time=' + Date.now();
      }
    }

  },
  methods: {
    modifyUserPass: function(userPhone) {
      eventBus.$emit('modifyUserPass', userPhone);
    },
    modifyUserPhone: function(userPhone) {
      eventBus.$emit('modifyUserPhone', userPhone);
    },
    uploadHeadImg: function(showName, userId) {
      eventBus.$emit('uploadHeadImg', showName, userId);
    },
    uploadWxQRCode: function(showName, userId) {
      eventBus.$emit('uploadWxQRCode', showName, userId);
    },
    wnBind: function(userId) {
      eventBus.$emit('wnBind', userId);
    },
    async deleteHeadImgConfirm() {
      if (!this.user.headImg) {
        this.$message.error('请先上传头像！');
        return;
      }
      this.$ebConfirm('确定要删除头像吗?')
        .then(() => {
          this.deleteHeadImg();
        })
        .catch(() => {});
    },
    async deleteHeadImg() {
      let params = {
        userId: this.user.userId,
        showName: this.user.showName,
        deleteHeadImg: 1
      };
      try {
        let { data } = await setUser(params);
        if (data.returnCode === '01') {
          this.$message.success('删除头像成功！');
          eventBus.$emit('loadUserInfo', 'headImg');
        } else {
          this.$message.error('删除头像失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    },
    async unbindWxConfirm() {
      this.$ebConfirm('确定解绑微信吗?')
        .then(() => {
          this.unbindWx();
        })
        .catch(() => {});
    },
    async unbindWx() {
      let params = {
        userId: this.user.userId,
        deleteWxBind: 1
      };
      try {
        let { data } = await setUser(params);
        if (data.returnCode === '01') {
          this.$message.success('微信解绑成功！');
          this.user.openidPublic = '';
        } else {
          this.$message.error('微信解绑失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    },
    async removeWxQRCodeImgConfirm() {
      if (!this.user.wxQRCodeImg) {
        this.$message.error('请先上传微信二维码！');
        return;
      }
      this.$ebConfirm('确定要删除微信二维码吗?')
        .then(() => {
          this.removeWxQRCodeImg();
        })
        .catch(() => {});
    },
    async removeWxQRCodeImg() {
      let params = {
        userId: this.user.userId,
        showName: this.user.showName,
        deleteWxQRCodeImg: 1
      };
      try {
        let { data } = await setUser(params);
        if (data.returnCode === '01') {
          this.$message.success('删除微信二维码成功！');
          eventBus.$emit('loadUserInfo', 'wxQrcode');
        } else {
          this.$message.error('删除微信二维码失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    },
    saveUserInfo: function(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveUser();
        } else {
          this.$message.error('请检查表单信息是否通过验证！');
          return false;
        }
      });
    },
    async saveUser() {
      var params = {
        userId: this.user.userId,
        showName: this.user.showName,
        userName: this.user.userName,
        trueName: this.user.trueName,
        userEmail: this.user.userEmail,
        phone: this.user.phone,
        address: this.user.address,
        selfIntroduce: this.user.selfIntroduce
      };
      try {
        let { data } = await setUser(params);
        if (data.returnCode === '01') {
          this.$message.success('修改用户信息成功！');
          this.$router.push('/user/view');
        } else {
          this.$message.error('修改用户信息失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    },
    beforeDestroy() {
      eventBus.$off('modifyUserPhoneSucess');
    }
  }
};
</script>
<style scoped lang="less">
#UserSettingDetail {
  .eb-input .el-input__inner {
    width: 650px;
  }
  .eb-textarea .el-textarea__inner {
    width: 650px;
  }
  .panel-box {
    width: 90%;
    margin: 0 auto;
    padding-top: 30px;
    padding-bottom: 30px;
    .firstItem {
      margin-top: 15px;
    }
    .logo-img {
      border: 1px solid #cccccc;
      width: 60px;
      height: 45px;
      vertical-align: middle;
    }
    .head-img {
      border: 1px solid #cccccc;
      width: 140px;
      height: 210px;
      display: table-cell;
      vertical-align: middle;
    }
    .wxQRCode-img {
      width: 147px;
      height: 147px;
      border: 1px solid #e0e0e0;
      padding: 5px 5px;
      background-color: white;
      display: inline-block;
      img {
        width: 147px;
        height: 147px;
      }
    }
    img {
      max-width: 100%;
    }
  }
  .row-field {
    width: 100%;
    min-height: 30px;
    line-height: 30px;
    margin-left: 0px;
    font-family: '微软雅黑';
    display: flex;
    flex-wrap: wrap;
    .row-left {
      width: 145px;
      margin-left: 0px;
      margin-right: 15px;
    }
    .row-right {
      width: 66%;
      padding-right: 15px;
      .i-font {
        display: flex;
        align-items: flex-end;
        height: 210px;
      }
    }
  }
  .companyName {
    line-height: 50px;
    font-size: 1.5em;
    font-weight: bold;
    padding-left: 0px;
    color: black;
  }
  .icon-select-rule-tpl {
    cursor: pointer;
    color: rgb(251, 91, 59);
    font-size: 22px;
    position: relative;
    top: 3px;
  }
  .icon-modify1 {
    font-size: 20px;
  }
}
</style>
